module.exports = __webpack_public_path__ + "media/images/pic/contact/aneta-kawa-b709c45177f743f6a10969fd4f220375.jpeg";